import { For } from 'solid-js';
import { SITE } from '../../config/site';

export function StoryWindow() {
  return (
    <div class="window-body app-window-body story-window">
      <header class="document-header">
        <h1>My Story</h1>
        <p>A compact account of the path behind the projects on this workstation.</p>
      </header>
      <div class="story-timeline">
        <For each={SITE.story}>
          {(chapter, index) => (
            <article class="story-chapter">
              <div class="story-marker" aria-hidden="true">{index() + 1}</div>
              <div class="story-copy">
                <small>{chapter.period}</small>
                <h2>{chapter.title}</h2>
                <p>{chapter.text}</p>
              </div>
            </article>
          )}
        </For>
      </div>
    </div>
  );
}
